import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { FC, ReactNode } from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import Sidebar from './Sidebar';

const MainWrapper = styled(Box)(
  ({ theme }) => `
        flex: 1 1 auto;
        display: flex;
        height: 100%;
        
        @media (min-width: ${theme.breakpoints.values.lg}px) {
            
        }
`
);

const MainContent = styled(Box)(
  ({ theme }) => `
    margin-top: ${theme.header.height};
    padding-bottom: ${theme.spacing(0)};
    flex: 1 1 auto;
    overflow-y: auto;
    overflow-x: hidden;
`
);
interface AccentSidebarLayoutProps {
  children?: ReactNode;
}

const AccentSidebarLayout: FC<AccentSidebarLayoutProps> = () => {
  return (
    <>
      <Header />
      <Sidebar />
      <MainWrapper>
        <MainContent>
          <Outlet />
        </MainContent>
      </MainWrapper>
    </>
  );
};

export default AccentSidebarLayout;
